import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import Cookies from "universal-cookie";

export const getDeviceName = createAsyncThunk(
    'url/getDeviceName',
    async (configObj) => {
        const response = await Axios(configObj)
        return response.data
    }
)

const dirWebApp = process.env.REACT_APP_DIR_PRO

const cookies = new Cookies()

const urlSlice = createSlice({
    name: 'url',
    initialState: {
        urlSeguridad: '',
        urlSchoolApi: '',
        urlInvoiceApi: '',
        urlCursosApi: '',
        headersAPI: {
            'Authorization': process.env.REACT_APP_TOKEN_API,
            'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
            'Content-Type': 'application/json'
        },
        ApiResponse: ''
    },
    reducers: {},
    extraReducers: {
        [getDeviceName.pending]: (state, action) => {
            state.ApiResponse = 'pending'
        },
        [getDeviceName.fulfilled]: (state, action) => {                                    
            state.urlSeguridad = process.env.REACT_APP_URL_API_SEG
            state.urlSchoolApi = process.env.REACT_APP_URL_API
            state.urlInvoiceApi =process.env.REACT_APP_URL_API_INVOICE
            state.urlCursosApi = process.env.REACT_APP_URL_API_CURSOS
            state.ApiResponse = 'succeed'

            cookies.set('__urlSeguridad', JSON.stringify(state.urlSeguridad), { path: dirWebApp })
            cookies.set('__urlSchoolApi', JSON.stringify(state.urlSchoolApi), { path: dirWebApp })
            cookies.set('__urlInvoiceApi', JSON.stringify(state.urlInvoiceApi), { path: dirWebApp })
            cookies.set('__urlCursosApi', JSON.stringify(state.urlCursosApi), { path: dirWebApp })
        },
        [getDeviceName.rejected]: (state, action) => {
            state.urlSeguridad = process.env.REACT_APP_URL_API_SEG
            state.urlSchoolApi = process.env.REACT_APP_URL_API
            state.urlInvoiceApi =process.env.REACT_APP_URL_API_INVOICE
            state.urlCursosApi = process.env.REACT_APP_URL_API_CURSOS
            state.ApiResponse = 'rejected'

            cookies.set('__urlSeguridad', JSON.stringify(state.urlSeguridad), { path: dirWebApp })
            cookies.set('__urlSchoolApi', JSON.stringify(state.urlSchoolApi), { path: dirWebApp })            
            cookies.set('__urlInvoiceApi', JSON.stringify(state.urlInvoiceApi), { path: dirWebApp })
            cookies.set('__urlCursosApi', JSON.stringify(state.urlCursosApi), { path: dirWebApp })
        }

    },
})

export default urlSlice.reducer